export default __webpack_public_path__ + "static/media/Muli-Bold.41ef56b6.ttf";